<div class="update-wrapper">
  <div class="change-language" (click)="changeLanguage()">
    <span>{{ getCurrentLang() | uppercase }}</span>
    <ion-icon name="chevron-down"></ion-icon>
  </div>
  <img src="/assets/images/logo-yova.png" alt="Logo yova" />
  <div>
    <h1>{{ 'PUBLIC.forceAppUpdate.H1' | translate }}</h1>
    <h1>{{ 'PUBLIC.forceAppUpdate.H2' | translate }}</h1>
    <ion-button mode="ios" expand="block" (click)="openApp()" color="white">{{ 'PUBLIC.forceAppUpdate.CTA' | translate }}</ion-button>
    <small *ngIf="showCacheNote" [innerHTML]="'PUBLIC.forceAppUpdate.cache_note_android_only' | translate"></small>
  </div>
</div>
